import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle'

// Connects to data-controller="swiper"
export default class extends Controller {

  static values = {
    config: String
  }

  static targets = ["container", "prevEl", "nextEl"]

  connect() {
    const swiperConfig = this.getSwiperConfig();
    const container = this.hasContainerTarget ? this.containerTarget : this.element;
    this.swiper = new Swiper(container, swiperConfig);
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  getSwiperConfig() {
    const configName = this.configValue || "default";

    const baseConfig = {
      slidesPerView: 1.5,
      autoHeight: false,
      spaceBetween: 24,
      loop: false,
      watchSlidesProgress: true,
      navigation: {
        enabled: true,
        prevEl: this.hasPrevElTarget ? this.prevElTarget : ".swiper-button-prev",
        nextEl: this.hasNextElTarget ? this.nextElTarget : ".swiper-button-next",
      },
      pagination: {
        enabled: false
      },
      breakpointsBase: 'window'
    };

    const configurations = {
      default: {
        ...baseConfig,
        creativeEffect: {
          limitProgress: 5,
          prev: { shadow: true },
          next: { shadow: true },
        },
        lazy: { enabled: true },
        breakpoints: {
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 }
        }
      },

      configCol3: {
        ...baseConfig,
        breakpoints: {
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 }
        }
      }
    }

    return configurations[configName] || configurations.default;

  }
}
